module.exports = __webpack_public_path__ + "static/langojango-tagalog-language-phrasebook-7ba560432bf9c660cd8540804b7a063a.png";